import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  FormErrorMessage,
} from '@chakra-ui/react'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
interface InviteUserModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (values: {
    name: string;
    email: string
    role: 'ADMIN' | 'STANDARD'
  }) => Promise<void>
}
const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  role: Yup.string()
    .oneOf(['ADMIN', 'STANDARD'], 'Invalid role')
    .required('Role is required'),
})
export const InviteUserModal = ({
  isOpen,
  onClose,
  onSubmit,
}: InviteUserModalProps) => {
  const initialValues = {
    name: '',
    email: '',
    role: 'STANDARD' as const,
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent bg="gray.800" border="1px" borderColor="gray.700">
        <ModalHeader color="white">Invite User</ModalHeader>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              await onSubmit(values)
              resetForm()
            } catch (error) {
              console.error('Error inviting user:', error)
            } finally {
              setSubmitting(false)
            }
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <ModalBody>
                <VStack spacing={4}>
                <Field name="name">
                    {({ field, form }: any) => (
                      <FormControl
                        isInvalid={Boolean(form.errors.name && form.touched.name)}
                      >
                        <FormLabel color="gray.300">Name</FormLabel>
                        <Input
                          {...field}
                          type="text"
                          placeholder="John"
                          bg="gray.700"
                          border="none"
                          color="white"
                        />
                        <FormErrorMessage>{form.errors.name}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>



                  <Field name="email">
                    {({ field, form }: any) => (
                      <FormControl
                        isInvalid={form.errors.email && form.touched.email}
                      >
                        <FormLabel color="gray.300">Email Address</FormLabel>
                        <Input
                          {...field}
                          type="email"
                          placeholder="user@example.com"
                          bg="gray.700"
                          border="none"
                          color="white"
                        />
                        <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>


                  <Field name="role">
                    {({ field, form }: any) => (
                      <FormControl
                        isInvalid={form.errors.role && form.touched.role}
                      >
                        <FormLabel color="gray.300">Role</FormLabel>
                        <Select
                          {...field}
                          bg="gray.700"
                          border="none"
                          color="white"
                        >
                          <option value="STANDARD">Standard</option>
                          <option value="ADMIN">Admin</option>
                        </Select>
                        <FormErrorMessage>{form.errors.role}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </VStack>
              </ModalBody>
              <ModalFooter gap={2}>
                <Button variant="ghost" onClick={onClose} color="gray.300">
                  Cancel
                </Button>
                <Button
                  type="submit"
                  bg="#ff3d00"
                  color="white"
                  isLoading={isSubmitting}
                  _hover={{
                    bg: '#e53700',
                    boxShadow: '0 0 20px rgba(255, 61, 0, 0.5)',
                  }}
                >
                  Send Invite
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  )
}
